import { Banner } from 'components/section/banner';
import { LinkTerkait } from 'components/section/link-terkait';
import { Main } from '../components/frame/main';
import { Section1 } from './../components/section/section-1';
import { Section2 } from './../components/section/section-2';
import { Section3 } from './../components/section/section-3';
import { Section4 } from './../components/section/section-4';
import { Sliders } from 'components/pages-portal/slider';
import { SliderHome } from 'components/pages-portal/sliderHome';

const Home = () => {

    return (
        <Main>
            {/* <Banner slug={'test'}/> */}
            <SliderHome />
            <Section1 />
            <Section4 />
            <Section2 />
            <Section3 />
            <LinkTerkait />
            {/* <Section5 /> */}
            {/* <Section6 />
            <Section7 /> */}
        </Main>
    )
};

export default Home;